import stepLabelClasses from "@mui/material/StepLabel/stepLabelClasses";
import stepClasses from "@mui/material/Step/stepClasses";
export const MuiStepTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                position: "relative",
                flexGrow: 1,
                padding: 0,
                [`.${stepLabelClasses.root}`]: {
                    padding: `${dt.stacked.small} ${dt.inline.medium} ${dt.stacked.small} 0`,
                },
                [`&.${stepClasses.completed}`]: {
                    ".PixelIcon": {
                        backgroundColor: dt.color.palette.primary[50],
                    },
                },
            },
        },
    };
};
